export const VapIdKey = "BDSUXRCSP6vaXmIm2CevpnWSq609JtwieFiYe3k6tSP33PcDpLZSa3Se6jg6mT8iGuciqp_eQaBkjoDsLTzZFR8";